module.exports = __webpack_public_path__ + "static/media/ProMastersHeader_carousel.f9968381.png";